import { localizeNumber } from '@helpers/locale';

export default (initialNumber) => {
  if (!initialNumber) { return ''; }

  const digits = initialNumber.toString().length;

  if (digits >= 0 && digits <= 3) {
    return `${localizeNumber(initialNumber)} bytes`;
  }

  if (digits > 3 && digits <= 6) {
    return `${localizeNumber(Math.round(initialNumber / 1000))} KB`;
  }

  if (digits > 6 && digits <= 9) {
    return `${localizeNumber(Math.round(initialNumber / 1000000))} MB`;
  }

  return `${localizeNumber(Math.round(initialNumber / 10000000) / 100)} GB`;
};
